import React from 'react';
import { Link } from 'react-router-dom';

import Button from 'ui/Button';
import Tooltip from 'ui/Tooltip';

import { Path } from '../../utils/routes';
import { useCurrentUser } from '../../utils/user';

const AddinSavedDiagramsButton: React.FC = () => {
  const { user } = useCurrentUser();

  const buttonDisabled = user?.created_nr_of_sankeys === 0;

  return (
    <Tooltip
      content="Please create some diagrams first"
      disabled={!buttonDisabled}
    >
      <Link to={Path.Sankeys}>
        <Button disabled={buttonDisabled} variant="primary-outline" w="280px">
          Saved diagrams
        </Button>
      </Link>
    </Tooltip>
  );
};

export default AddinSavedDiagramsButton;
